import React from 'react';

import { Banner } from '@stitch-fix/mode-react';
import { useProductDetailsPageContext } from '../ProductDetailsPage/ProductDetailsPageContext/ProductDetailsPageContext';
import formatBusinessLine from '../../helpers/businessLineFormatter';

/**
 * A banner that prompts the client to create a new account under a different business line.
 *
 * Banner headline copy for Men's, Women's, Kid's lines:
 *    "Our apologies! Men’s and Women’s styles need to be  purchased through separate accounts."
 *
 * Banner headline copy for shell accounts:
 *    "Your email address is currently linked to a different account"
 *
 * Banner body copy:
 *    "To buy this item, please create a new {formattedItemBusinessLine} account with a different email address.
 *     Sorry for the hassle."
 */

const BusinessLineMismatchBanner = () => {
  const [state] = useProductDetailsPageContext();

  const formattedClientBusinessLine = state.clientBusinessLine
    ? formatBusinessLine(state.clientBusinessLine)
    : '';

  const formattedShoppingBagBusinessLine = state.shoppingBagBusinessLine
    ? formatBusinessLine(state.shoppingBagBusinessLine)
    : '';

  const formattedItemBusinessLine = state.productBusinessLine
    ? formatBusinessLine(state.productBusinessLine)
    : '';

  const headline =
    formattedClientBusinessLine || state.shoppingBagBusinessLineIsMismatched
      ? `Our apologies! Men’s and Women’s styles need to be purchased through separate accounts.`
      : `Your email address is currently linked to a different account`;

  const message = state.shoppingBagBusinessLineIsMismatched
    ? `Please buy the ${formattedShoppingBagBusinessLine} styles in your bag first and then create a new account with a different email address to buy ${formattedItemBusinessLine} styles. Sorry for the hassle.`
    : `To buy the ${formattedItemBusinessLine} styles please log out and create a new account with a different email address. Sorry for the hassle.`;

  return (
    <Banner headline={headline} mb={{ below: true, sm: 1.5 }}>
      {message}
    </Banner>
  );
};

export default BusinessLineMismatchBanner;
